export default function isInvalid(validation: any, field: any) {
  return (
    validation &&
    validation.inner &&
    validation.inner.find((err: any) => err.path === field)
  );
}
